import styled from 'styled-components';

import { toRem } from '@wecasa/common/src/utils/styles';

import { textStyle } from '../../base-text/base-text';
import type { WithClassNameProps } from '../../types';

const StyledLabel = styled.label<{
  $isActive: boolean;
  $color: string;
}>`
  ${textStyle}

  display: block;
  position: absolute;
  top: 11px;
  user-select: none;
  pointer-events: none;
  color: ${({ $color }) => $color};
  font-weight: 500;
  transition: all 0.2s ease, background-color 0s;
  opacity: 0.7;

  ${({ $isActive }) =>
    $isActive &&
    `
    font-size: ${toRem(10)};
    font-weight: 700;
    top: 3px;
    opacity: 1;
  `}
`;

type AnimatedPlaceholderProps = WithClassNameProps & {
  color: string;
  inputId: string;
  isActive: boolean;
  label: string;
};

const AnimatedPlaceholder = ({ className, color, inputId, isActive, label }: AnimatedPlaceholderProps) => (
  <StyledLabel className={className} htmlFor={inputId} $color={color} $isActive={isActive}>
    {label}
  </StyledLabel>
);

export default AnimatedPlaceholder;
